import { render, staticRenderFns } from "./NewsDetail57.vue?vue&type=template&id=3b6a2679&scoped=true"
import script from "./NewsDetail57.vue?vue&type=script&lang=js"
export * from "./NewsDetail57.vue?vue&type=script&lang=js"
import style0 from "./NewsDetail57.vue?vue&type=style&index=0&id=3b6a2679&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6a2679",
  null
  
)

export default component.exports